import { Injectable } from '@angular/core';
import { WidgetService } from './widget.service';

export interface WidgetConfig {
  inputs?: Record<string, any>;
  outputs?: Record<string, any>;
}

@Injectable({
  providedIn: 'root'
})
export class WidgetConfigService {

  constructor() {}

  /**
   * Get the configuration for a specific widget type in a given context
   */
  getWidgetConfig(
    widgetName: WidgetService.WidgetName, 
    context: 'grid' | 'chat',
    contextHandlers: {
      onEditFile?: (event: any) => void;
      onEditWorkflow?: (event: any) => void;
      onEditMCPConfig?: (event: any) => void;
      // Add other common handlers as needed
    }
  ): WidgetConfig {
    
    const configs: Partial<Record<WidgetService.WidgetName, WidgetConfig>> = {
      PromptsWidget: {
        outputs: {
          onEditFile: contextHandlers.onEditFile
        }
      },
      LLMWorkflowsWidget: {
        outputs: {
          onEditFile: contextHandlers.onEditFile,
          onEditWorkflow: contextHandlers.onEditWorkflow
        }
      },
      JobsWidget: {
        outputs: {
          onEditFile: contextHandlers.onEditFile
        }
      },
      ChatWidget: {
        outputs: {
          onEditMCPConfig: contextHandlers.onEditMCPConfig
        }
      },
      DefinitionsWidget: {
        outputs: {
          onEditFile: contextHandlers.onEditFile
        }
      },
      WorkflowWidget: {
        outputs: {
          onEditFile: contextHandlers.onEditFile
        }
      }
      // Add other widget configurations as needed
    };

    return configs[widgetName] || {};
  }

  /**
   * Helper method to get all possible output events for a widget
   * Useful for understanding what events a widget can emit
   */
  getWidgetOutputEvents(widgetName: WidgetService.WidgetName): string[] {
    const config = this.getWidgetConfig(widgetName, 'grid', {});
    return Object.keys(config.outputs || {});
  }
}
